import React, { createContext, useContext, useEffect, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [sidebarHidden, setSidebarHidden] = useState(() => {
    try { return localStorage.getItem("sidebarHidden") === "1"; } catch { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem("sidebarHidden", sidebarHidden ? "1" : "0"); } catch { /* ignore */ }
  }, [sidebarHidden]);
  const toggleSidebar = () => setSidebarHidden((v) => !v);
  return <UIContext.Provider value={{ sidebarHidden, setSidebarHidden, toggleSidebar }}>{children}</UIContext.Provider>;
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used within UIProvider");
  return ctx;
}
